import * as angular from 'angular';
import { mxNovaChartPieComponent } from './components/mx-nova-chart-pie/mx-nova-chart-pie';
import { provideNovaDesignSystem, NovaPieChart, applyNovaTheme, createNovaTheme } from '@matrix42/nova';

function configNova() {
	const initedNovaComponents = [NovaPieChart]; // eslint-disable-line

	const novaTheme = createNovaTheme();
	novaTheme.fontFamily.sans = 'Roboto, "Helvetica Neue", sans-serif';
	novaTheme.fontSize.label = 1.2;
	novaTheme.fontSize.p = 1.4;
	novaTheme.fontSize.h6 = 1.6;
	novaTheme.fontSize.h5 = 1.8;
	novaTheme.fontSize.h4 = 2;
	novaTheme.fontSize.h3 = 2.4;
	novaTheme.fontSize.h2 = 3;
	novaTheme.fontSize.h1 = 3.6;
	novaTheme.fontSize['h1-xl'] = 4.8;
	novaTheme.fontSize['h1-2xl'] = 6;
	novaTheme.fontSize['h1-3xl'] = 7.2;
	novaTheme.fontSize.code = 1.4;
	applyNovaTheme(novaTheme, 'light', 10);

	provideNovaDesignSystem({ theme: novaTheme, themeMode: 'light' });
}

export const novaModule = angular
	.module('mx.nova', [])
	.config(configNova) // init Nova here
	.component('mxNovaChartPie', mxNovaChartPieComponent);
